import { FC } from 'react';

export interface StartGdprCheckButtonInputProps {
  documentId: string;
  providerId: string | null;
  checkStarted: boolean;
  disabled?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const StartGdprCheckButton: FC<StartGdprCheckButtonInputProps> = ({
  documentId,
  providerId,
  checkStarted,
  disabled = false,
  onClick,
}) => {
  return (
    <button
      className="flex cursor-pointer items-center gap-1 rounded border border-[#D0D0CE] bg-transparent px-2 py-1 text-sm text-black hover:bg-gray-50 disabled:cursor-default disabled:opacity-50"
      data-document-id={documentId}
      data-check-started={checkStarted}
      onClick={(e) => onClick(e)}
      title={!providerId ? 'Assign a provider to begin the check.' : 'GDPR Start Review'}
      disabled={!providerId || disabled}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3332 7.45455C13.3332 10.4819 11.0578 13.3125 7.99984 13.9999C4.94184 13.3125 2.6665 10.4819 2.6665 7.45455V5.07655C2.6665 4.53521 2.99384 4.04721 3.49517 3.84255L6.8285 2.47855C7.57917 2.17121 8.4205 2.17121 9.17117 2.47855L12.5045 3.84255C13.0058 4.04788 13.3332 4.53521 13.3332 5.07655V7.45455V7.45455Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.1665 6.75L7.6665 9.25L6.1665 7.75" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      Check
    </button>
  );
};
